import { render, staticRenderFns } from "./QuestionContent.vue?vue&type=template&id=ddd026da"
import script from "./QuestionContent.vue?vue&type=script&lang=js"
export * from "./QuestionContent.vue?vue&type=script&lang=js"
import style0 from "./QuestionContent.vue?vue&type=style&index=0&id=ddd026da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports